import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { MirrorService } from 'services/MirrorService';

import { isNotificationsPage } from 'helpers/route';
import { fetchNotificationData, getIsFirstLoading } from 'store/notifications';

import { PopularUsers } from 'components/sections/PopularUsers';
import { DesktopPageWrapper } from 'components/shared/DesktopPageWrapper';
import { Header } from 'components/shared/Header';

import { ActivityMenu } from './submodules/ActivityMenu';

export const DesktopActivityWrapper: React.FC = ({ children }) => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const isFirstLoading = useSelector(getIsFirstLoading);

  useEffect(() => {
    if (isFirstLoading && !isNotificationsPage(pathname)) {
      dispatch(fetchNotificationData());
    }
  }, [dispatch, isFirstLoading, pathname]);

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Header />

      <DesktopPageWrapper>
        {!MirrorService.isGoogleCertificationsGroup && <PopularUsers />}

        <ActivityMenu />

        {children}
      </DesktopPageWrapper>
    </div>
  );
};
